export const getDateString = isoDate => {
  const curIsoDate = new Date(isoDate.replace('Z', ''));

  return `${new Date(curIsoDate)
    .toLocaleString('ru', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
    .slice(0, -3)}`;
};
